import { render, staticRenderFns } from "./customFormItem.vue?vue&type=template&id=47ce09ee&"
import script from "./customFormItem.vue?vue&type=script&lang=js&"
export * from "./customFormItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports